module.exports = __webpack_public_path__ + "img/machineThre-img6.f6bfaa29.jpg";